import color from '@theme/Colors';
import React, { SVGProps } from 'react';

type Props = {} & SVGProps<SVGSVGElement>;

export default function ExemptVrnsIcon(props: Props) {
    return (
        <svg
            width={'26px'}
            height={'26px'}
            viewBox="0 0 50.8 50.8"
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            {...props}
        >
            <path
                className="icon-svg-stroke"
                fill="none"
                stroke='currentColor'
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3.175}
                d="M43.526 24.31c0 6.942-4.172 12.009-8.748 15.485-3.906 2.966-7.936 4.638-9.381 5.184-1.442-.54-5.478-2.212-9.387-5.184-4.571-3.475-8.736-8.541-8.736-15.484v-9.902c4.442-.663 7.957-4.16 8.624-8.588h19.004c.668 4.428 4.182 7.925 8.624 8.588z"
            />
            <path
                className="icon-svg-stroke"
                fill="none"
                stroke='currentColor'
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.117}
                d="M31.246 21.939c0-3.254-2.617-5.892-5.846-5.892s-5.845 2.638-5.845 5.892a5.9 5.9 0 0 0 2.922 5.101l-2.192 7.713h10.23l-2.192-7.713a5.9 5.9 0 0 0 2.923-5.101"
            />
        </svg>
    );
}
